import { createContext } from 'react';

// eslint-disable-next-line
export default createContext<any>([false, () => {}]);
